import {
  RESTAURANT_DETAILS_REQUEST,
  RESTAURANT_DETAILS_SUCCESS,
  RESTAURANT_DETAILS_FAIL,
} from "../constants/restaurantConstants";

export const restaurantDetailsReducer = (state = { restaurant: {} }, action) => {
  switch (action.type) {
    case RESTAURANT_DETAILS_REQUEST:
      return { loading: true, restaurant: {} };
    case RESTAURANT_DETAILS_SUCCESS:
      return { loading: false, restaurant: action.payload };
    case RESTAURANT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
